import { Card, Col, Row } from "react-bootstrap";
import { IComplaintDetails } from "../../../api/IComplaint";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { ComplaintIcon } from "../../../leap-components/icons/LeapIcons";

interface ComplaintHeaderProps {
  complaintDetails: IComplaintDetails;
  licenceProfile: ILicenceProfile;
}

const ComplaintHeader = ({
  complaintDetails,
  licenceProfile,
}: ComplaintHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <ComplaintIcon />
                  </td>
                  <td>
                    <h2>Complaint: {complaintDetails.reference}</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={complaintDetails.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows label={"Status"} value={complaintDetails.status} />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Licence Version"}
              value={complaintDetails.licence_regno}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ComplaintHeader;
